export default __webpack_public_path__ + "static/media/our-philosophy.44f9fab1.svg";